/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/viewmodels/write',["require", "exports", "common/viewmodelbase", "services/navigator", "services/trace", "areas/shopitemtemplate/models/dto", "areas/shopitemtemplate/services/shopitemtemplaterepository"], function (require, exports, common, navigator, trace, dto, Repository) {
    "use strict";
    var shopitemtemplateViewModel = (function (_super) {
        __extends(shopitemtemplateViewModel, _super);
        function shopitemtemplateViewModel() {
            _super.call(this);
            this.id = "";
            this.name = "";
            this.location = "";
            this.configurationXml = "";
            this.itemType = "";
            this.category = "";
            this.agb = "";
            this.memberType = "";
            this.hostVersion = "";
            this.chargeable = true;
            this.title = $.t("app:modules.shopitemtemplate.headline_title", { ifMissing: "Verwaltung der ShopItemTemplates" });
            ko.track(this, ["template", "id"]);
        }
        shopitemtemplateViewModel.prototype.onActivated = function (context) {
            var that = this;
            this.id = Guid.newGuid();
        };
        shopitemtemplateViewModel.prototype.save = function () {
            // TODO: LN Validierung der Eingaben !
            // if (this.selectedContacts().length == 0) {
            //	trace.traceError("Bitte geben Sie einen Empfänger in das Feld An ein.", null, "shopitemtemplate", true);
            //	return;
            //}
            var shopitemtemplate = new dto.Template();
            shopitemtemplate.templateId = this.id;
            shopitemtemplate.name = this.name;
            shopitemtemplate.category = this.category;
            shopitemtemplate.itemType = this.itemType;
            shopitemtemplate.target = this.location;
            shopitemtemplate.settingsXml = this.configurationXml;
            shopitemtemplate.memberType = this.memberType;
            if (!this.isValidGuid(shopitemtemplate.templateId)) {
                var errorMessage = $.t("app:modules.shopitemtemplatemessage_saveShopItemTemplateFailureIdNotValid", { ifMissing: "Fehler beim Speichern des ShopItemTemplates. Die Id ist nicht valide." });
                trace.traceError(errorMessage);
                return;
            }
            // send shopitemtemplate
            var workStatus = $.t("app:modules.shopitemtemplate.message_saveShopItemTemplate", { ifMissing: "ShopItemTemplate wird gespeichert..." });
            this.taskManager.startAsync(workStatus, function () {
                var repository = new Repository.ShopItemTemplateRepository();
                return repository.save(shopitemtemplate)
                    .then(function (data) {
                    navigator.goBack();
                }).fail(function (exception) {
                    var errorMessage = $.t("app:modules.shopitemtemplatemessage_createShopItemTemplateFailure", { ifMissing: "Fehler beim Neuanlegen des ShopItemTemplates: " });
                    trace.traceError(errorMessage + exception.responseText, null, "shopitemtemplate", true);
                });
            });
        };
        shopitemtemplateViewModel.prototype.isValidGuid = function (guid) {
            var regex = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$';
            var regexp = new RegExp(regex);
            return regexp.test(guid);
        };
        shopitemtemplateViewModel.prototype.cancel = function () {
            navigator.goBack();
        };
        return shopitemtemplateViewModel;
    }(common.ViewModelBase));
    var Guid = (function () {
        function Guid() {
        }
        Guid.newGuid = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
        return Guid;
    }());
    return shopitemtemplateViewModel;
});

